import * as React from 'react';
import * as main from "../../main.module.scss";
import * as program from "./style.module.scss";
import { Modal } from "../../../../Modal";
export const Program = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={`${program.program} ${main.hugs}`}>
      <div className="container">
        <h2 className={main.title}>Программа мастер-класса:</h2>
        <div className={`${main.container} ${main.violet}`}>
          <ul className={main.listTriple}>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/programm-01.png" alt=""/>
              <p>Экспресс диагностика вашей ситуации</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/programm-02.png" alt=""/>
              <p>Разбор традиционных путей профориентации и их недостатков</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/programm-03.png" alt=""/>
              <p>Конкретный алгоритм профориента&shy;ционной беседы с ребёнком, а те, кто будут смотреть вместе с ребёнком смогут сразу вместе провести базовое переориенти&shy;рование</p>
            </li>
          </ul>
          <div className={program.resultBlock}>
            <div className={program.info}>
              <h3>Результат:</h3>
              <p>вы перестанете беспокоиться за будущее ребёнка, а ребёнок получит систему координат, которая пригодится ему на всю жизнь</p>
              <button className={`${main.btn} ${main.btnOrange}`} onClick={()=>{setShowModal(true)}}>Зарегистрироваться</button>
            </div>
            <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/smiling-girl.png" alt=""/>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
